import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from '../routers/AppRouter';
import { clearAuthError } from '../actions/auth';

// This form is simply responsible for presenting the form, validating inputs, saving form data in 
// local state, and passing the form data to the onSubmit function prop that was passed in from parent.
// Goal is to keep track of local state for all of the inputs. Only when form has been validated successfully
// within the local onSubmit, do we want to dispatch an action. This action will be dispatched by the parent.
// If there are any form errors, the formError property (within the component state) will be set and
// the onSubmit passed from the parent component will not be called.
// If token was invalid or had api call errors (from the action that was dispatched from parent), 
// it will be logged as an auth.error on the redux store. The displayError() method here will check if
// either form error or auth error exists. If so, it shows the error message on top of the form. The 
// local Form error property will be reset to null (thru isValidForm method) when form is resubmitted with no errors. 
// The auth error property, on redux store will, be reset when user successfully changes password
// via startResetPw action. 
class ResetPwForm extends React.Component {
    constructor(props) {
        super(props);
        // local component state
        this.state = {
            password:           '',
            passwordConfirm:    '',
            id:     props.id ? props.id : '',
            token:  props.token ? props.token : '',
            formError: ''
        };
    }
    
    // -----------------------------------------------------------
    // Form events
    // -----------------------------------------------------------

    onPasswordChange = (e) => {
        const password = e.target.value.trim();     // assign input value to description; allows to use object shorthand on next line
        this.setState(() => ({ password })); // update description on local state using ES6 shorthand
    };

    onConfirmPasswordChange = (e) => {
        const passwordConfirm = e.target.value.trim();    
        this.setState(() => ({ passwordConfirm }));
    };

    // Note: this local onSubmit method does form validation, but does not dispatch the 
    // action responsible for logging in user and saving auth token. 
    // The dispatch is done by the onSubmit method passed in as a function prop, from the 
    // Parent page. The function prop (this.props.onSubmit) is invoked with data needed 
    // for the Parent page to decide if and when an action is dispatched.
    onSubmit = (e) => {
        e.preventDefault();

        // If no errors on the form, call the onSubmit method on parent component, which 
        // dispatches the startLogin action, which logins user, sets isAuthenticated, and
        // saves token.
        if (this.isValidForm()) {
            this.props.onSubmit({
                id:     this.state.id,
                token:  this.state.token,
                password: this.state.password
            });
        }; 
    };

    // -----------------------------------------------------------
    // On click handlers
    // -----------------------------------------------------------

    // Take user back to home page
    handleCancel = () => {
        history.push("/");
    }
 
    // -----------------------------------------------------------
    // Render method
    // -----------------------------------------------------------

    render() {
        return (
            <form className="form-forgotpw" onSubmit={this.onSubmit}>
                {this.displayError()}     
                <h3 className="modalstyle__title rc-mt-1">Enter New Password</h3>
                <h5 className="modalstyle__subtitle">
                   Please provide new password, and click Update
                </h5>
                <input 
                type="password"
                placeholder="Password (minimum 8 chars)"
                className="modalstyle__field"
                value={this.state.password}
                onChange={this.onPasswordChange}
            />
            <input 
                type="password"
                placeholder="Confirm Password"
                className="modalstyle__field"
                value={this.state.confirmPassword}
                onChange={this.onConfirmPasswordChange}
            />
            <div>
                <button type="button" className="button-shadow button--oval" 
                        onClick={this.handleCancel} >
                Cancel
                </button> 
                <span> &nbsp; &nbsp;</span>
                <button className="button button--oval">Update</button> 
            </div>
            </form>
        )
    }

    // -----------------------------------------------------------
    // Life cycle methods
    // -----------------------------------------------------------

    // If there is an auth error on the redux store, clear it before unmounting compoment
    componentWillUnmount() {
        if (this.props.auth.error) {
            this.props.clearAuthError();
        }
     }
    
    // renderConditionalForgotPassword = () =>  {
    //     if ( this.state.error.indexOf('already exist') !== -1 ) {
    //         return (
    //             <Link to="#" className="small-text-link">Forgot Password?</Link> 
    //         )
    //     }
    // };

    // -----------------------------------------------------------
    // Helper functions
    // -----------------------------------------------------------

    // It will check if a local form error exist first, and render error message.
    // If not, it checks for an auth error exist (that may have been triggered by login action). 
    // If found, it renders the authentication error 
    displayError = () => {
        if (this.state.formError) {
            return <p className="error rc-mt-1">{this.state.formError}</p>
        }
        if (this.props.auth.error) {
            return <p className="error rc-mt-1">{this.props.auth.error}</p>
        }
    }
  
    isValidForm = () => {
        let valid = false;
        if (!this.state.password) {
            this.setState(() => ({ formError: 'Please provide password'}))
        } else
        if (this.state.password.length < 8) {
            this.setState(() => ({ formError: 'Password minimum of 8 characters'}))
        } else
        if (!this.state.passwordConfirm ) {
            this.setState(() => ({ formError: 'Please provide password confirmation'}))
        } else
        if (this.state.password !== this.state.passwordConfirm) {
            this.setState(() => ({ formError: 'Passwords did not match, please update'}))
        } else {
            this.setState(() => ({ formError: ''}));
            valid = true;
        }
        return valid;
    }
   
} // END OF REACT component


// -----------------------------------------------------------
// Redux functions
// -----------------------------------------------------------

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

const mapDispatchToProps = (dispatch) => ({
    clearAuthError:     () => dispatch(clearAuthError()),
    sendResetPwMail:   () => dispatch(sendPwResetEmail(email))
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPwForm);


// {this.state.formError && <p className="form__error">{this.state.formError}</p>}
//             {this.props.auth.error && <p className="form__error">{this.props.auth.error}</p>}rops.auth.error && <p className="form__error">{this.props.auth.error}</p>}h.error && <p className="form__error">{this.props.auth.error}</p>}


// WEBPACK FOOTER //
// ./src/components/ResetPwForm.js